import React, { Component } from "react";
import Label from "../Components/Label";

const noLabelPadding = {
  paddingTop: '24px'
};

export class Textbox extends Component {
  render() {
    var type = "text";
    if (this.props.type) {
      type = this.props.type;
    }

    var label = <Label name={this.props.label_name} required={this.props.required} />
    if (!this.props.label_name) {
      label = <div style={noLabelPadding}></div>
    }

    
    return (
      <div>
        {label}
        <div className="form-group">
          <input
            className="form-control"
            type={type}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}